import React, { useCallback } from 'react';
import { useResubscribeDomain } from '../../../mutation/unsubscribe';
import { Button } from '../../../components/ui';
import { Modal as AntdModal } from 'antd';

type Props = {
  id: number,
};

export default function DomainResubscribeButton({ id }: Props) {
  const { mutate, isLoading } = useResubscribeDomain();
  const handleResubscribeDomain = useCallback(() => {
    AntdModal.confirm({
      title: `Resubscribe Organization`,
      content: `Are you sure you want to resubscribe to this domain`,
      onOk: () => mutate({ id }),
    });
  }, [mutate]);
  return (
    <Button
      className="email__resubscribe-btn"
      loading={isLoading}
      type="button"
      onClick={handleResubscribeDomain}
    >
      re-subscribe
    </Button>
  );
}
